export default {
  getActionsScheme: (state, params) => {
    let { tab, page, mode, step } = params;

    if (tab > 0 && state.schemes[page][mode].tabs) return state.schemes[page][mode].tabs.content[tab].actions;
    if (step > 0 && state.schemes[page][mode].steps) return state.schemes[page][mode].steps.content[step].actions;

    if (state.schemes[page])
      return mode === 'master' ? state.schemes[page].form[mode].actions : state.schemes[page][mode].actions;
  },

  getGroupButtons: (state, params) => {
    let { tab, page, mode, step } = params;
    let actionItems = [];

    if (tab > 0 && state.schemes[page][mode].tabs) {
      actionItems = actionItems.concat(
        state.schemes[page][mode].tabs.content[tab].fields.filter(f => f.type === 'i4proGroupButtons')
      );
      state.schemes[page][mode].tabs.content[tab].groups.forEach(g => {
        actionItems = actionItems.concat(g.fields.filter(f => f.type === 'i4proGroupButtons'));
      });
    }

    if (step > 0 && state.schemes[page][mode].steps) {
      actionItems = actionItems.concat(
        state.schemes[page][mode].steps.content[step].fields.filter(f => f.type === 'i4proGroupButtons')
      );
      state.schemes[page][mode].steps.content[step].groups.forEach(g => {
        actionItems = actionItems.concat(g.fields.filter(f => f.type === 'i4proGroupButtons'));
      });
    }

    if (state.schemes[page]) {
      if (mode === 'master') {
        let fieldsMaster =
          state.schemes[page].form[mode].fields === undefined
            ? state.schemes[page].form.fields
            : state.schemes[page].form[mode].fields;
        actionItems = actionItems.concat(fieldsMaster.filter(f => f.type === 'i4proGroupButtons'));
        state.schemes[page].form.groups.forEach(g => {
          actionItems = actionItems.concat(g.fields.filter(f => f.type === 'i4proGroupButtons'));
        });
      } else {
        if ('fields' in state.schemes[page][mode]) {
          actionItems = actionItems.concat(
            state.schemes[page][mode].fields.filter(f => f.type === 'i4proGroupButtons')
          );
        }

        if ('groups' in state.schemes[page][mode]) {
          state.schemes[page][mode].groups.forEach(g => {
            if ('fields' in g) {
              actionItems = actionItems.concat(g.fields.filter(f => f.type === 'i4proGroupButtons'));
            }
          });
        }
      }
    }

    return actionItems;
  },

  // Nova função que extrai para monitorar e executar alterações de propriedades em páginas irmãs
  // O array de subPages, é montado após a execução das conditions então temos essa função
  // Que fica checando se houve alguma altração do array de subPages, para executar novamente a validação se necessário
  monitorSubPagesChange: (getters, state, subPageOf, callback) => {
    let attempts = 0;
    const interval = setInterval(() => {
      let subPages = getters.subPages(state)(subPageOf);
      attempts += 1;
      if (!subPages) subPages = [];
      if (subPages.length > 0 || attempts >= 10) {
        clearInterval(interval);
        callback(subPages);
      }
    }, 100);
  },

  //Essa função era um trecho de código solto dentro da mutation que manipula a visibilidade das conditions da page
  //Foi extraída para cá para ser reutilizada de maneira mais legivel e limpa.
  setFieldVisibility: (state, { page, mode, tab, step, hideFields = [], readonlyFields = [], dynamic = false }) => {
    const setVisibility = fields => {
      if (dynamic === true) {
        fields.forEach(field => {
          if (field.items) {
            field.items.forEach(item => {
              if (!hideFields.includes(item.name)) {
                item.visible = !('hidden' in item);
              }
              if (!readonlyFields.includes(item.name)) {
                item.readonly = !('readonly' in item);
              }
            });
          } else {
            if (!hideFields.includes(field.model)) {
              field.visible = !('hidden' in field);
            }
            if (!readonlyFields.includes(field.model)) {
              field.readonly = !('readonly' in field);
            }
          }
        });
      } else if (dynamic === false) {
        fields.forEach(field => {
          const statePage = state.initialSchemes[page];
          const stateMode = statePage ? statePage[mode] : null;
          const stateFieldGroups = stateMode ? stateMode.groups : null;
          const stateTabGroups = stateMode && stateMode.tabs && stateMode.tabs.content[tab] ? stateMode.tabs.content[tab].groups : null;

          if (stateFieldGroups || stateTabGroups) {
            if (stateFieldGroups) {
              stateFieldGroups.forEach(group => {
                if (group.fields) {
                  group.fields.forEach(groupField => {
                    if (groupField.model === field.model) {
                      // Verifica e altera a propriedade visible
                      field.visible = groupField.visible ? true : false;

                      // Verifica e altera a propriedade readonly
                      field.readonly = groupField.readonly ? true : false;

                      // Verifica se propriedade hidden é true e altera a visibilidade do field
                      if (groupField.hidden) {
                        field.visible = false;
                      }
                    }
                  });
                }
              });
            }

            if (stateTabGroups) {
              stateTabGroups.forEach(group => {
                if (group.fields) {
                  group.fields.forEach(groupField => {
                    if (groupField.model === field.model) {
                      // Verifica e altera a propriedade visible
                      field.visible = groupField.visible ? true : false;

                      // Verifica e altera a propriedade readonly
                      field.readonly = groupField.readonly ? true : false;

                      // Verifica se propriedade hidden é true e altera a visibilidade do field
                      if (groupField.hidden) {
                        field.visible = false;
                      }
                    }
                  });
                }
              });
            }
          }
           else {
            if ('hidden' in field) {
              field.visible = false;
            } else {
              field.visible = true;
            }

            if ('readonly' in field) {
              field.readonly = true;
            } else {
              field.readonly = false;
            }
          }

        });
      }
    };

    if (tab) {
      setVisibility(state.schemes[page][mode].tabs.content[tab].fields);
      const { groups } = state.schemes[page][mode].tabs.content[tab];
      groups.forEach(group => setVisibility(group.fields));
    } else if (step) {
      setVisibility(state.schemes[page][mode].steps.content[step].fields);
      const { groups } = state.schemes[page][mode].steps.content[step];
      groups.forEach(group => setVisibility(group.fields));
    } else {
      if (mode === 'master') {
        const fieldsMaster = state.schemes[page].form[mode].fields || state.schemes[page].form.fields;
        setVisibility(fieldsMaster);
      } else if ('fields' in state.schemes[page][mode]) {
        setVisibility(state.schemes[page][mode].fields);
      }

      const { groups } = state.schemes[page][mode];
      if (groups) {
        groups.forEach(group => setVisibility(group.fields));
      }
    }
  }
};
